import { ICON_MAP } from './icon-picker-icons';

/**
 * Componente que renderiza ícone do registro pelo nome.
 *
 * Substitui o antigo helper `renderIconByName(name, className)` que voltava
 * JSX direto. Agora consumers usam `<IconByName name="Phone" />` — preserva
 * `react-refresh/only-export-components` (arquivo exporta SÓ componente).
 */
export interface IconByNameProps {
  name: string | null | undefined;
  className?: string;
}

export function IconByName({ name, className }: IconByNameProps) {
  if (!name) return null;
  const Icon = ICON_MAP[name];
  if (!Icon) return null;
  return <Icon className={className ?? 'w-4 h-4'} aria-hidden="true" />;
}
